import Layout from "../components/layout";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import FormInput from "../components/formInput";
import {useEffect, useRef, useState} from "react";
import cn from "classnames";
import {useHistory} from "react-router";
import axios from "../axios/axios";
import {Endpoints} from "../axios/endpoints";
import Lightbox from "react-image-lightbox";
import {toast} from "react-toastify";
import {Link} from "react-router-dom";

function NewOrderView() {

    const [restaurants, setRestaurants] = useState([]);
    const [restaurant, setRestaurant] = useState("-1");
    const [restaurantDetails, setRestaurantDetails] = useState();
    const [validated, setVaildated] = useState(false);

    const orderDetailsRef = useRef();
    const orderRef = useRef();

    const [whoIsCalling, setWhoIsCalling] = useState("");
    const [restaurantName, setRestaurantName] = useState("");
    const [timeTill, setTimeTill] = useState("11:30");
    const [timeWhen, setTimeWhen] = useState("12:00");
    const [paypal, setPaypal] = useState(false);
    const [paypalEmail, setPaypalEmail] = useState("");
    const [price, setPrice] = useState()
    const [order, setOrder] = useState("")

    const [isOpen, setIsOpen] = useState(false)

    const handleOpenMenu = e => {
        e.preventDefault()
        e.stopPropagation()

        setIsOpen(true)
    }

    let history = useHistory()

    const handleSubmit = e => {
        e.preventDefault();
        e.stopPropagation();
        setVaildated(false);


        if (!orderDetailsRef.current.checkValidity() || !orderRef.current.checkValidity()) {
            setVaildated(true);
            return;
        }

        axios({
            method: "post",
            url: Endpoints.ORDERS,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            },
            data: {
                "restaurant_id": restaurant !== "-1" ? restaurantDetails.id : "-1",
                "restaurant_name": restaurantName,
                "who_is_calling": whoIsCalling,
                "ordering_for": timeWhen,
                "accept_until": timeTill,
                "payment_methods": paypal ? ["BAR", "PAYPAL"] : ["BAR"],
                "paypal_email": paypalEmail,
                "user_orders": {
                    "price": price,
                    "order": order
                }
            }
        }).then(res => {
            history.push("/");
        }).catch(err => {
            if (err.response && err.response.status) {
                switch (err.response.status) {
                    case 400:
                        if (err.response.data.code === 1009) {
                            toast.warn("Bitte überprüfe die eingegebenen Uhrzeiten. Wir mögen Zeitreisen auch, aber noch unterstützen wir sie nicht.")
                            break;
                        }

                        toast.warn("Da ist was schiefgelaufen. Bitte überprüfe deine Eingaben nochmal.")
                        break;
                    case 401:
                        toast.error("Du musst dich erneut einloggen")
                        history.push("/logout")
                        break;
                    default:
                        toast.error("Da ist was schiefgelaufen. Bitte versuche es später noch einmal.")
                        break;
                }
            }
        })

    }

    useEffect(() => {
        axios({
            method: "get",
            url: Endpoints.RESTAURANTS,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        }).then(res => {
            setRestaurants(res.data || [])
        }).catch(err => {
            if (err.response && err.response.status) {
                switch (err.response.status) {
                    case 401:
                        toast.error("Du musst dich erneut einloggen")
                        history.push("/logout")
                        break;
                    default:
                        toast.error("Da ist was schiefgelaufen. Bitte versuche es später noch einmal.")
                        break;
                }
            }
        })
    }, [])

    useEffect(() => {
        if (!restaurant || restaurant === "-1") {
            return
        }

        axios({
            method: "get",
            url: Endpoints.RESTAURANT(restaurant),
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        }).then(res => {
            setRestaurantDetails(res.data || [])
        }).catch(err => {
            if (err.response && err.response.status) {
                switch (err.response.status) {
                    case 401:
                        toast.error("Du musst dich erneut einloggen")
                        history.push("/logout")
                        break;
                    default:
                        toast.error("Da ist was schiefgelaufen. Bitte versuche es später noch einmal.")
                        break;
                }
            }
        })
    }, [restaurant])

    return (
        <Layout>
            <div className="card shadow mb-3">
                <div className="card-body">
                    <h2 className="card-title text-center">
                        <FontAwesomeIcon className="text-primary" icon={["fas", "plus"]}/> Neue Bestellug
                    </h2>

                    <form ref={orderDetailsRef} onSubmit={e => {
                        e.preventDefault()
                        e.stopPropagation()
                    }} className={cn({"was-validated": validated})}>
                        <div className="mb-3">
                            <label className="form-label">Wo willst du bestellen?</label>

                            <select className="form-select" value={restaurant}
                                    onChange={e => setRestaurant(e.target.value)} placeholder="Schreiben zum starten..."
                                    required>
                                {restaurants.map(e =>
                                    <option
                                        className={cn({"restaurant-updated": e.id === "1696498380693307392"})}
                                        key={e.id}
                                        value={e.id}>{e.name}{e.id === "1696498380693307392" ? " - neue Karte" : null}</option>
                                )}
                                <option value="-1">Nicht dabei?</option>
                            </select>
                        </div>
                        {
                            restaurant === "-1" ?
                                <FormInput value={restaurantName} minLength={1} maxLength={255}
                                           setValue={setRestaurantName}
                                           label="Wie heißt das Restaurant"
                                           placeholder="Name"/> : null
                        }
                        <FormInput label="Wer ruft an?" placeholder="Du" value={whoIsCalling} minLength={1}
                                   maxLength={255}
                                   setValue={setWhoIsCalling}
                                   required/>
                        <div className="row">
                            <div className="col-md">
                                <FormInput type="time" value={timeWhen} setValue={setTimeWhen}
                                           label="Wann wird das Essen da sein?" placeholder="12:00 Uhr" required/>
                            </div>
                            <div className="col-md">
                                <FormInput type="time" value={timeTill} setValue={setTimeTill}
                                           label="Bis wann können andere an der Bestellung teilnehmen?"
                                           placeholder="11:30 Uhr"
                                           required/>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label className="form-label">Welche Bezahlmöglichkeiten aktzepierst du?</label>
                            <div className="col-md">
                                <div className="form-check">
                                    <input className="form-check-input" type="checkbox" checked disabled value=""/>
                                    <label className="form-check-label">
                                        <FontAwesomeIcon className="text-primary" icon={["fas", "money-bill"]}/> Bar
                                    </label>
                                </div>
                            </div>
                            <div className="col-md">
                                <div className="form-check">
                                    <input className="form-check-input" checked={paypal}
                                           onChange={e => setPaypal(e.target.checked)} type="checkbox" value=""/>
                                    <label className="form-check-label">
                                        <FontAwesomeIcon className="text-primary" icon={["fab", "paypal"]}/> PayPal
                                    </label>
                                </div>
                                <FormInput type="email" value={paypalEmail} setValue={setPaypalEmail}
                                           placeholder="pay@joshirando.de"
                                           required disabled={!paypal}/>
                            </div>
                        </div>
                    </form>
                    {
                        restaurant !== "-1" ? (
                            <div className="mb-3">
                                <Link to={"/menu/" + restaurant} className="btn btn-primary text-light" target="_blank">Karte
                                    öffnen
                                </Link>
                                {isOpen && (
                                    <Lightbox
                                        mainSrc={"/karten/" + restaurant + ".jpg"}
                                        onCloseRequest={() => setIsOpen(false)}
                                    />
                                )}
                            </div>
                        ) : null
                    }
                </div>
            </div>


            {
                restaurant && restaurantDetails ? (
                    <>
                        {
                            restaurant !== "-1" ? (
                                <div className="card shadow mb-3">
                                    <div className="card-body">
                                        <h2 className="card-title"><FontAwesomeIcon className="text-primary"
                                                                                    icon={restaurantDetails.icon}/> {restaurantDetails.name}
                                        </h2>
                                        <div className="row">
                                            <div className="col-md">
                                                <div>{restaurantDetails.address.street} {restaurantDetails.address.number}</div>
                                                <div>{restaurantDetails.address.postcode} {restaurantDetails.address.city}</div>
                                            </div>
                                            <div className="col-md">
                                                <a className="h3 text-decoration-none text-black"
                                                   href={`tel:${restaurantDetails.telephone.replace(/[ \/\-\\]/g, "")}`}><FontAwesomeIcon
                                                    className="text-primary"
                                                    icon={["fas", "phone-alt"]}/> {restaurantDetails.telephone}
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : null
                        }
                    </>
                ) : null
            }
            <div className="card shadow mb-3" onSubmit={e => handleSubmit(e)}>
                <div className="card-body">
                    <h2 className="card-title">Was willst du bestellen?</h2>
                    <form ref={orderRef} onSubmit={e => handleSubmit(e)} className={cn({"was-validated": validated})}>
                        <textarea value={order} minLength={1} maxLength={255} onChange={e => setOrder(e.target.value)}
                                  className="form-control mb-2"
                                  placeholder="Halbes Schwein, Schubkarre Pommes" required/>
                        <FormInput type="number" min="0.00" max="10000.00" step="0.01" label="Preis (in €)"
                                   placeholder="5.50"
                                   value={price} setValue={setPrice} required/>
                    </form>

                    <button type="submit" className="btn btn-primary text-light float-end"
                            onClick={e => handleSubmit(e)}>Erstellen
                    </button>
                </div>
            </div>
        </Layout>
    )
}

export default NewOrderView;

